<template>
  <div class="loading-container">
    <div v-if="isFetching" class="loading-overlay">
      <div class="loader"></div>
    </div>
    <span v-else v-show="isShowPage">
      <v-row>
        <v-col class="text-right">
          <!-- <span v-if="items.length > 0">{{ items.length + 1 + ' data ditemukan' }}</span> -->
          <v-btn
            class="ma-2"
            depressed
            outlined
            :color="colorActive"
            @click="openDialogFilter()"
          >
            <v-icon left :color="colorActive">
              $ic-filter
            </v-icon>
            Filter
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!isFetching" style="height: 90vh">
        <l-map
          ref="map"
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          style="height: 600px; margin-top:20px; "
        >
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          />

            <l-control-fullscreen position="topright"  :options="fullscreenOptions" />

          <l-marker
            v-for="(marker, idx) in locationMarkerList"
            :key="idx"
            :options="{ opacity: 1.0, riseOnHover: true }"
            ref="markers"
            :lat-lng="marker.position"
          >
            <l-popup :options="{ closeButton: false }">
              <table class="popup-table">
                <tr>
                  <td class="popup-property">Nama :</td>
                  <td class="popup-value">{{ capitalize(marker.nama) }}</td>
                </tr>
              </table>
            </l-popup>
            <l-icon
                :icon-size="['15']"
                :icon-url="iconSelector(marker)"
            />
          </l-marker>
        </l-map>
      </v-row>
<!--      <hr v-if="showMap" class="line-separator">-->
<!--      <span class="page-sub-title">{{ table_title }}</span>-->
<!--      <v-row align="center" justify="center" class="mt-1">-->
<!--        <v-col cols="3">-->
<!--          <v-text-field-->
<!--            append-icon="mdi-magnify"-->
<!--            outlined-->
<!--            solo-->
<!--            hide-details-->
<!--            v-model="search"-->
<!--            class="search"-->
<!--            placeholder="Search..."-->
<!--            color="#2671D9"-->
<!--          >-->
<!--          </v-text-field>-->
<!--        </v-col>-->
<!--        &lt;!&ndash; <v-col>-->
<!--          <v-btn-->
<!--            class="ma-2"-->
<!--            depressed-->
<!--            outlined-->
<!--            color="#2671D9"-->
<!--            @click="openDialog()"-->
<!--          >-->
<!--            <v-icon left color="#2671D9">-->
<!--              $ic-filter-->
<!--            </v-icon>-->
<!--            Filter-->
<!--          </v-btn>-->
<!--        </v-col> &ndash;&gt;-->
<!--        <v-spacer></v-spacer>-->
<!--        <v-col class="text-right">-->
<!--          <v-btn-->
<!--            class="ma-2"-->
<!--            depressed-->
<!--            outlined-->
<!--            color="#2671D9"-->
<!--            @click="exportExcel()"-->
<!--          >-->
<!--            <v-icon left color="#2671D9">-->
<!--              $ic-export-excel-->
<!--            </v-icon>-->
<!--            Export Excel-->
<!--          </v-btn>-->
<!--          <download-excel-->
<!--            id="d"-->
<!--            v-show="false"-->
<!--            :data="itemsExcel"-->
<!--            :name="'Detail Transaksi ' + this.dateExportFormat()"-->
<!--            :header="'Detail Transaksi ' + this.dateExportFormat()"-->
<!--          >-->
<!--          </download-excel>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--      <v-row>-->
<!--        <v-col class="pt-5">-->
<!--          &lt;!&ndash; <Table :headers="headers" :loading="isFetching" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="20">-->
<!--          </Table> &ndash;&gt;-->
<!--          <v-data-table-->
<!--            :headers="headers"-->
<!--            :items="items"-->
<!--            :items-per-page="itemsPerPage"-->
<!--            class="datatable"-->
<!--            :search="search"-->
<!--            hide-default-footer-->
<!--            :page.sync="page"-->
<!--            @page-count="pageCount = $event"-->
<!--          >-->
<!--            <template v-slot:item.jml_transaksi="{ item }">-->
<!--              {{ formatCurrency(item.jml_transaksi).split(',')[0] }}-->
<!--            </template>-->
<!--          </v-data-table>-->
<!--          <v-row>-->
<!--            <v-col class="mt-5" cols="6">-->
<!--              Menampilkan-->
<!--              <v-select-->
<!--                v-model="itemsPerPage"-->
<!--                :items="[5, 10, 20, 30, 50]"-->
<!--                dense-->
<!--                solo-->
<!--                flat-->
<!--                class="ml-1 mr-1 size-select"-->
<!--                @change="itemsPerPage = parseInt($event, 10); page = 1;"-->
<!--              ></v-select>-->
<!--              data dari <b>{{ items.length }}</b>-->
<!--            </v-col>-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-col class="text-right mt-5" cols="6">-->
<!--              <v-pagination v-model="page" :length="pageCount" :total-visible="5"></v-pagination>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span>{{ dialogTitle }}</span>
              </v-col>
              <v-col cols="1" class="text-right">
                <v-btn
                  icon
                  x-small
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="pb-0 pt-1">
                  <v-list>
                    <template v-for="(item, index) in chargeBoxList">
                      <v-list-item
                        :key="index"
                      >
                        <v-icon v-if="item.isActive" class="mr-5">$ic-spklu-blue</v-icon>
                        <v-icon v-else class="mr-5">$ic-spklu-red</v-icon>
                        <v-list-item-content>
                          <v-list-item-title v-html="item.namaChargebox"></v-list-item-title>
                          <v-list-item-subtitle v-html="item.dayaChargebox"></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-tooltip
                            right
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                              </v-btn>
                            </template>
                            <span v-for="(connector, j) in item.connectors" :key="connector.j">
                              <table>
                                <tr>
                                  <td>{{ '(' + parseInt(j + 1) + ')' }}</td>
                                  <td>Nama Connector</td>
                                  <td>: {{ connector.namaKonektor }}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>Status Connector</td>
                                  <td>:
                                    <span>{{ enumToStatus(connector.status) }}</span>
                                  </td>
                                </tr>
                              </table>
                            </span>
                          </v-tooltip>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              depressed
              :color="colorActive"
              dark
              @click="dialog = false"
            >
              Kembali
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogFilter"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span>Filter Data</span>
              </v-col>
              <v-col class="text-right">
                <v-btn
                  icon
                  x-small
                  @click="dialogFilter = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="pb-5 pt-1">
                  <div class="label-custom mb-2" :style="'color:' + colorActive">Unit</div>
                  <v-text-field
                    v-model="input.searchBranch"
                    label="Cari Lokasi"
                    dense
                    solo
                    flat
                    outlined
                    clearable
                  >
                  </v-text-field>
                  <span>Selected: {{ input.branch.name ? input.branch.name : 'unit belum dipilih' }}
                    <v-icon v-show="input.branch.id" @click="input.branch = {}; active = []">mdi-close</v-icon>
                  </span>
                  <div v-show="!input.branch.id" style="overflow-y: scroll; height:300px;">
                    <v-treeview
                      activatable
                      :active="active"
                      :items="tempOptionsBranch"
                      @update:active="treeClick"
                    ></v-treeview>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              depressed
              color="#999999"
              text
              @click="dialogFilter = false"
            >
              Kembali
            </v-btn>
            <v-btn
              small
              depressed
              :color="colorActive"
              @click="dialogFilter = false; reGetData();"
              dark
            >
              Cari
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </span>
  </div>
  </template>
<script>
import 'leaflet/dist/leaflet.css'
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from 'vue2-leaflet'
import SpkluService from '@/services/default/SpkluService'
import RefService from '@/services/default/RefService'
import icHomeCharging from '@/assets/maps/ic-home-charging.png'
import LControlFullscreen from 'vue2-leaflet-fullscreen'

const spkluService = SpkluService.build()
const refService = RefService.build()
export default {
  name: 'spklu-lokasi-spklu',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControlFullscreen
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    // apus
    // cardItems: {
    //   hijau: 0,
    //   kuning: 0,
    //   merah: 0,
    //   biru: 0
    // },
    headers: [
      // { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'nama', text: 'Nama SPKLU', align: 'left' },
      { value: 'jml_charger', text: 'Jumlah Charger', align: 'center' },
      { value: 'jml_connector', text: 'Jumlah Connector', align: 'center' },
      { value: 'jml_transaksi', text: 'Jumlah Transaksi', align: 'center' },
      { value: 'kategori', text: 'Kategori SPKLU', align: 'center' }
    ],
    items: [],
    search: '',
    sortSettings: '',
    isFetching: false, // for datatable
    locationMarkerList: [],

    // map properties
    zoom: 5,
    center: latLng(-2.372369, 115.421875),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showParagraph: false,
    mapOptions: {
      // zoomSnap: 0.5
      zoomControl: true,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: true,
      boxZoom: false,
      keyboard: false,
      dragging: true
    },
    fullscreenOptions: {
      title: {
        false: 'Switch to full-screen view',
        true: 'Exit full-screen mode'
      }
    },
    showMap: false,
    isShowPage: false,
    mapObj: {},
    table_title: '',
    timer: '',
    // datepicker
    menuDateRange: false,
    dateRange: null,
    activePicker: null,
    // dialog properties
    dialog: false,
    dialogTitle: '',
    chargeBoxList: [],
    showTooltip: false,
    // client side pagination properties
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    // filter
    input: {
      jml_transaksi: {},
      branch: {},
      spklu: {},
      searchBranch: '',
      is_active: {}
    },
    dialogFilter: false,
    // optionsJmlTransaksi: [
    //   { id: 'hijau', name: 'Jumlah Transaksi > 500' },
    //   { id: 'kuning', name: 'Jumlah Transaksi 100 - 500' },
    //   { id: 'merah', name: 'Jumlah Transaksi < 100' },
    //   { id: 'biru', name: 'SPKLU Hyundai' }
    // ],
    optionsAvailability: [
      { id: 'active', name: 'Available' },
      { id: 'inactive', name: 'Unavailable' }
    ],
    // optionsSpklu: [],
    optionsLokasi: [],
    optionsBranch: [],
    tempOptionsBranch: [],
    searchSpkluKeyword: '',
    awaitingSearch: false,
    active: [],
    itemsExcel: []
  }),
  async created () {
    this.table_title = 'Detail Transaksi'
    this.isShowPage = true
    this.showMap = true
    this.getSpkluCoordinate()
    // this.getSpkluCard()
    this.getBranchList()
  },
  computed: {
    formattedDateRange () {
      if (this.dateRange) {
        if (this.input.periode.id === 'monthly') {
          return this.dateRange.split('-')[0]
        } else if (this.input.periode.id === 'hourly' || this.input.periode.id === 'daily') {
          return this.dateRange
        } else if (this.input.periode.id === 'weekly') {
          return this.dateRange.join(' ~ ')
        }
      }
      return ''
    }
  },
  mounted: function () {
    // if (this.$route.path === '/dashboard/spklu-fast-charging') {
    //   this.$nextTick(() => {
    //     this.map = this.$refs.map.mapObject
    //     this.mapObj = this.map
    //   })

    //   // re-get data every 1 minute
    //   this.timer = setInterval(() => {
    //     this.resetData()
    //     // this.getSpkluACHomeCharging()
    //     const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
    //     if (tableQuery) {
    //       this.getDataTable(tableQuery.page, tableQuery.size)
    //     } else {
    //       this.getDataTable()
    //     }
    //     this.isShowPage = true
    //   }, 60000)
    // }
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    'input.branch': function (val) {
      if (val.id) {
        this.getOptionsSpklu(val.id)
      }
    },
    'input.searchBranch': function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch
      } else {
        this.tempOptionsBranch = this.containComplex(this.optionsBranch, val)
      }
    },
    menuDateRange (val) {
      if (this.input.periode.id === 'monthly') {
        val && this.$nextTick(() => (this.activePicker = 'YEAR'))
      } else if (this.input.periode.id === 'daily') {
        val && this.$nextTick(() => (this.activePicker = 'MONTH'))
      } else if (this.input.periode.id === 'hourly') {
        val && this.$nextTick(() => (this.activePicker = 'DATE'))
      } else {
        val && this.$nextTick(() => (this.activePicker = null))
      }
    }
    // searchSpkluKeyword (val) {
    //   const self = this
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       if (val !== '' && val !== null) {
    //         self.getOptionsSpklu()
    //       }
    //       self.awaitingSearch = false
    //     }, 1000)
    //   }
    //   this.awaitingSearch = true
    // }
  },
  methods: {
    setDateRange (date) {
      this.$refs.menuDateRange.save(date)
    },
    async getSpkluCoordinate (param) {
      this.isFetching = true

      const response = await spkluService.getCordinatesHC(param)
      const { data: { data } } = response

      data.map((obj, idx) => {
        Object.assign(obj, { id: idx })
      })

      // let firstLoad = true
      this.locationMarkerList = []
      for (let i = 0; i < data.length; i++) {
        // set location marker
        const position = latLng(data[i].latitude, data[i].longitude)

        // find existing index
        const idx = this.locationMarkerList.findIndex(x => x.id === data[i].id)
        if (idx === -1) {
          const newmarker = {
            id: data[i].id,
            nama: data[i].nama,
            position: position,
            latitude: data[i].latitude,
            longitude: data[i].longitude
          }
          this.locationMarkerList.push(newmarker)
        }
      }

      // set datatable client side data
      this.items = this.locationMarkerList.sort(function (a, b) {
        return b.jml_transaksi - a.jml_transaksi
      })

      const temp = this.items
      // reform data for excel export
      this.itemsExcel = await temp.map((item, index) => {
        return {
          Nomor: index + 1,
          'ID SPKLU': item.id,
          Nama: item.nama,
          Alamat: item.alamat,
          'Kapasitas (kW)': item.daya,
          Status: item.status,
          'Jumlah Transaksi': item.jml_transaksi,
          'Jumlah Charger': item.jml_charger,
          'Jumlah Connector': item.jml_connector,
          'Kategori SPKLU': item.kategori,
          Latitude: item.latitude,
          Longitude: item.longitude
        }
      })

      this.isFetching = false
    },
    async openDialog (marker) {
      await this.getSpkluAvailability(marker.id)
      this.dialogTitle = marker.nama
      this.dialog = true
    },
    async getSpkluAvailability (id) {
      const param = {
        idSpklu: id
      }
      const response = await spkluService.getDetailAvailabilitySpklu(param)
      const { data: { data } } = response
      this.chargeBoxList = data
    },
    iconSelector (data) {
      return icHomeCharging
    },
    async exportExcel () {
      document.getElementById('d').click()
    },
    openDialogFilter () {
      this.dialogFilter = true
    },
    async getBranchList () {
      const param = {
        companyId: 1,
        branchId: ''
      }
      const response = await refService.getBranchList(param)
      const { data: { data } } = response

      const temp = data.map((item) => {
        // remap level 1
        item.child = item?.child?.map((item2) => {
          return {
            id: item2.id,
            name: item2.id.split('').join('.') + ' - ' + item2.name
            // children: item2.child
          }
        })
        return {
          id: item.id,
          name: item.id.split('').join('.') + ' - ' + item.name,
          children: item.child
        }
      })

      this.optionsBranch = temp
      this.tempOptionsBranch = temp

      localStorage.setItem('branch_list', JSON.stringify({
        data: temp
      }))
    },
    treeClick (value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
        this.input.branch = this.findComplexPerencanaan(branch, value[0])
      }
    },
    async getOptionsSpklu (id) {
      this.paging.page = 0
      this.paging.size = 999

      const param = Object.assign({ q: id }, this.paging)
      const response = await refService.getSpkluList(param)
      const { data } = response
      if (data.success !== true) return

      this.optionsSpklu = data.data.content.map((data) => {
        return {
          id: data.idSpklu,
          name: data.spkluName
        }
      })
    },
    async reGetData () {
      let q = ''

      if (this.input.spklu && this.input.spklu.id) {
        q = this.input.spklu.id
      } else if (this.input.branch && this.input.branch.id) {
        q = this.input.branch.id
      }

      const param = {
        q: q
      }

      await this.getSpkluCoordinate(param)
      // this.getSpkluCard({ q: param.q })
    }
    // changeDateRangeType () {
    //   // this.dateRange = null
    //   // if (this.input.periode.id === 'hourly' || this.input.periode.id === 'daily' || this.input.periode.id === 'monthly' || this.input.periode.id === 'yearly') {
    //   //   this.dateRange = null
    //   // } else {
    //   //   // for weekly
    //   //   this.dateRange = []
    //   // }
    // },
    // dpTypeChooser () {
    //   if ((this.input.periode && this.input.periode.id === 'monthly') || (this.input.periode && this.input.periode.id === 'hourly')) return undefined
    //   else if (this.input.periode && this.input.periode.id === 'daily') return 'month'
    //   else return 'date'
    // }
  }
}
</script>
  <style scoped>

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0); /* Hitam transparan */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  /* HTML: <div class="loader"></div> */
  .loader {
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    background:
        radial-gradient(farthest-side,#707070 94%,#0000) top/8px 8px no-repeat,
        conic-gradient(#0000 30%,#707070);
    -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);
    animation: l13 1s infinite linear;
  }
  @keyframes l13{
    100%{transform: rotate(1turn)}
  }

  .summary-alert-title {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }

    .summary-alert-value {
      font-weight: 600;
      font-size: 24px;
      color: #333333;
    }

    .search {
      height: 48px;
    }

    .leaflet-popup-close-button {
      color: none;
    }

    .leaflet-container {
      font-family: 'Inter';
    }

    .popup-property {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #9A9A9A;
    }

    .popup-value {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #000000;
    }

    .popup-table tr td {
      padding: 5px;
    }

    .v-dialog__content--active {
      z-index: 224 !important;
    }

    .vue2leaflet-map {
      z-index: 200 !important;
    }
  </style>
